import { render, staticRenderFns } from "./RadioButtonDisabledExtension.vue?vue&type=template&id=24227b21&scoped=true&"
import script from "./RadioButtonDisabledExtension.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonDisabledExtension.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtonDisabledExtension.vue?vue&type=style&index=0&id=24227b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24227b21",
  null
  
)

export default component.exports